module.exports = __webpack_public_path__ + "static/media/peer_rating_intro.b89fc3f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer_rating_intro.svg
// module id = 1860
// module chunks = 0